var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.loading } }, [
    !_vm.justificationCompleted && _vm.state === "9"
      ? _c("div", [
          _vm.showJustificationInput
            ? _c("div", { staticClass: "row mt-3" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("vs-textarea", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: _vm.state === "9", max: 2000 },
                          expression: "{ required: state === '9', max: 2000 }"
                        }
                      ],
                      staticClass: "w-100 mt-3",
                      attrs: {
                        label: "Justificación de edición",
                        width: "100%",
                        name: "justification",
                        height: "100px",
                        maxlength: "900",
                        counter: "900",
                        "data-vv-as": "justificación"
                      },
                      model: {
                        value: _vm.justification,
                        callback: function($$v) {
                          _vm.justification = $$v
                        },
                        expression: "justification"
                      }
                    }),
                    _vm.errors.first("metadata.justification")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                            staticStyle: { height: "32px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "span-text-validation" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("metadata.justification")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 text-right" },
                  [
                    _c(
                      "vs-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "",
                            expression: "''"
                          }
                        ],
                        staticClass: "mr-2 btn btn-primary",
                        on: { click: _vm.continueToEditMeta }
                      },
                      [_vm._v(" Continuar ")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm.showForm && "dnt" in _vm.detailsFile
      ? _c(
          "form",
          {
            attrs: { autocomplete: "off", "data-vv-scope": "metadata" },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "b-card",
              { staticClass: "mt-3", attrs: { title: "Metadata" } },
              [
                !_vm.fromEdit
                  ? _c("h4", { staticClass: "text-primary" }, [
                      _vm._v(
                        " Si quieres editar los destinatarios y adjuntos, realiza las modificaciones antes en el modal a continuación y luego edita/completa la metadata de forma habitual. "
                      )
                    ])
                  : _vm._e(),
                !_vm.fromEdit
                  ? _c(
                      "b-modal",
                      {
                        ref: "modalMetadata",
                        attrs: {
                          size: "xl",
                          "hide-footer": "",
                          "no-close-on-backdrop": "",
                          title: "Metadata del expediente"
                        }
                      },
                      [
                        _c("DocumentProcessingMeta", {
                          attrs: { notify: _vm.notify },
                          on: { "close-modal": _vm.closeModal }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.fromEdit
                  ? _c("div", { staticClass: "row my-5" }, [
                      _c(
                        "div",
                        { staticClass: "col-12 text-left" },
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass: "mr-2 btn btn-warning",
                              attrs: { disabled: _vm.loading },
                              on: {
                                click: function($event) {
                                  return _vm.verDatos()
                                }
                              }
                            },
                            [_vm._v(" Ver información ")]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                !_vm.fromEdit ? _c("ReadOnlyMetaData") : _vm._e(),
                _vm.getSenderFile !== "conventional" &&
                _vm.getSenderFile !== "commission"
                  ? _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: { label: "Nombre" },
                            model: {
                              value: _vm.name,
                              callback: function($$v) {
                                _vm.name = $$v
                              },
                              expression: "name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: { label: "Dirección" },
                            model: {
                              value: _vm.address,
                              callback: function($$v) {
                                _vm.address = $$v
                              },
                              expression: "address"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: { regex: _vm.phoneRegex },
                                expression: "{ regex: phoneRegex }"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Teléfono",
                              placeholder: "Escriba en formato +56912345678",
                              "data-vv-as": "teléfono",
                              name: "phone",
                              danger: _vm.errors.has("metadata.phone"),
                              "danger-text": _vm.errors.first("metadata.phone"),
                              success:
                                !_vm.errors.has("metadata.phone") &&
                                _vm.phone.length > 0
                            },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                !_vm.fromEdit
                  ? _c("div", { staticClass: "row mt-3" }, [
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              label: "Descripción",
                              "data-vv-as": "descripción",
                              name: "alternativeTitle"
                            },
                            model: {
                              value: _vm.metadataDescription,
                              callback: function($$v) {
                                _vm.metadataDescription = $$v
                              },
                              expression: "metadataDescription"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              label: "Título alternativo",
                              "data-vv-as": "titulo alternativo",
                              name: "alternativeTitle"
                            },
                            model: {
                              value: _vm.metadataAlternativeTitle,
                              callback: function($$v) {
                                _vm.metadataAlternativeTitle = $$v
                              },
                              expression: "metadataAlternativeTitle"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              label: "ID SAIP",
                              "data-vv-as": "id Saip",
                              name: "idSaip"
                            },
                            model: {
                              value: _vm.metadataIdentifierSaip,
                              callback: function($$v) {
                                _vm.metadataIdentifierSaip = $$v
                              },
                              expression: "metadataIdentifierSaip"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("label", [_vm._v("Fecha del documento")]),
                          _c("b-form-datepicker", {
                            attrs: {
                              locale: "es",
                              placeholder: "Fecha del documento",
                              name: "documentDate",
                              "label-help":
                                "Puede usar las flechas del teclado y espacio"
                            },
                            model: {
                              value: _vm.metadataDocumentDate,
                              callback: function($$v) {
                                _vm.metadataDocumentDate = $$v
                              },
                              expression: "metadataDocumentDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("label", [_vm._v("Fecha de finalización")]),
                          _c("b-form-datepicker", {
                            attrs: {
                              locale: "es",
                              placeholder: "Fecha de finalización",
                              name: "documentEndDate",
                              "label-help":
                                "Puede usar las flechas del teclado y espacio"
                            },
                            model: {
                              value: _vm.metadataDocumentEndDate,
                              callback: function($$v) {
                                _vm.metadataDocumentEndDate = $$v
                              },
                              expression: "metadataDocumentEndDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12 mt-3" },
                        [
                          _c("ListUser", {
                            staticClass: "w-100 mb-0",
                            attrs: {
                              autocomplete: "",
                              label: "Autores internos",
                              name: "authors",
                              "data-vv-as": "autores",
                              onlyRol: ""
                            },
                            on: { "full-user": _vm.addInternAuthor }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-5 mt-3" },
                        [
                          _c("vs-input", {
                            staticClass: "w-100",
                            attrs: {
                              label: "Autores externos",
                              "data-vv-as": "autores",
                              name: "authors"
                            },
                            model: {
                              value: _vm.metadata.externalAuthorName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.metadata,
                                  "externalAuthorName",
                                  $$v
                                )
                              },
                              expression: "metadata.externalAuthorName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-5 mt-3" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Rol Autor externo" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "descripcion",
                                  options: _vm.externAuthorsRoles,
                                  reduce: function(rol) {
                                    return rol.valor
                                  },
                                  name: "rolType"
                                },
                                model: {
                                  value: _vm.metadata.externalAuthorRol,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.metadata,
                                      "externalAuthorRol",
                                      $$v
                                    )
                                  },
                                  expression: "metadata.externalAuthorRol"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.metadata.externalAuthorRol === "Otro"
                            ? _c("vs-input", {
                                staticClass: "w-100",
                                attrs: {
                                  label: "Rol Autor externo",
                                  "data-vv-as": "autores",
                                  name: "authors"
                                },
                                model: {
                                  value: _vm.metadata.externalAuthorRolFree,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.metadata,
                                      "externalAuthorRolFree",
                                      $$v
                                    )
                                  },
                                  expression: "metadata.externalAuthorRolFree"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2 mt-5" },
                        [
                          _c(
                            "vs-button",
                            {
                              staticClass: "mr-2 mt-5 btn btn-primary",
                              on: { click: _vm.addExternalAuthor }
                            },
                            [_vm._v(" Agregar ")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12 mt-3" },
                        [
                          _vm.metadata.internAuthors.length
                            ? _c(
                                "b-table-simple",
                                { attrs: { hover: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c(
                                            "b-th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Nombre")]
                                          ),
                                          _c(
                                            "b-th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Rol")]
                                          ),
                                          _c(
                                            "b-th",
                                            {
                                              staticClass: "text-center",
                                              attrs: { scope: "col" }
                                            },
                                            [_vm._v("Acción")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-tbody",
                                    _vm._l(_vm.metadata.internAuthors, function(
                                      internAuthor
                                    ) {
                                      return _c(
                                        "b-tr",
                                        { key: internAuthor.id },
                                        [
                                          _c("b-td", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center"
                                              },
                                              [
                                                _c("vs-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "person",
                                                    size: "medium"
                                                  }
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      internAuthor[
                                                        "dc.contributor.name"
                                                      ]
                                                    ) +
                                                    " "
                                                )
                                              ],
                                              1
                                            )
                                          ]),
                                          _c(
                                            "b-td",
                                            [
                                              _c("vs-input", {
                                                staticClass: "w-100",
                                                attrs: { readonly: "" },
                                                model: {
                                                  value:
                                                    internAuthor[
                                                      "dc.contributor.type"
                                                    ],
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      internAuthor,
                                                      "dc.contributor.type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "internAuthor['dc.contributor.type']"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-td",
                                            { staticClass: "text-center" },
                                            [
                                              _c("vs-icon", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: "Eliminar",
                                                    expression: "'Eliminar'"
                                                  }
                                                ],
                                                staticClass: "cursor-pointer",
                                                attrs: {
                                                  icon: "remove_circle_outline",
                                                  size: "small",
                                                  color: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeMetadataAuthor(
                                                      "intern",
                                                      internAuthor
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Unidad productora" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  label: "label",
                                  options: _vm.productionUnitOptions,
                                  reduce: function(rol) {
                                    return rol.label
                                  },
                                  name: "productionUnit"
                                },
                                model: {
                                  value: _vm.metadata.productionUnit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.metadata,
                                      "productionUnit",
                                      $$v
                                    )
                                  },
                                  expression: "metadata.productionUnit"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.metadata.productionUnit === "Otro"
                        ? _c(
                            "div",
                            { staticClass: "col-6 mt-3" },
                            [
                              _c("vs-input", {
                                staticClass: "w-100",
                                attrs: {
                                  label: "Unidad productora",
                                  "data-vv-as": "unidad productora",
                                  name: "productionUnitOther"
                                },
                                model: {
                                  value: _vm.metadata.productionUnitOther,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.metadata,
                                      "productionUnitOther",
                                      $$v
                                    )
                                  },
                                  expression: "metadata.productionUnitOther"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("vs-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "w-100",
                        attrs: {
                          label: "Título",
                          "data-vv-as": "titulo",
                          name: "title",
                          danger: _vm.errors.has("metadata.title"),
                          "danger-text": _vm.errors.first("metadata.title"),
                          success:
                            !_vm.errors.has("metadata.title") &&
                            _vm.title.length > 0
                        },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("ClassificationList", {
                        attrs: { value: _vm.clasification },
                        model: {
                          value: _vm.clasification,
                          callback: function($$v) {
                            _vm.clasification = $$v
                          },
                          expression: "clasification"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 mb-2 mt-3" },
                    [
                      _c("label", [_vm._v("Palabras clave")]),
                      _c("Keywords", {
                        model: {
                          value: _vm.keywords,
                          callback: function($$v) {
                            _vm.keywords = $$v
                          },
                          expression: "keywords"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("label", [_vm._v("Materia")]),
                      _c("treeselect", {
                        attrs: {
                          placeholder: "Seleccione...",
                          options: _vm.ontology
                        },
                        model: {
                          value: _vm.constitute,
                          callback: function($$v) {
                            _vm.constitute = $$v
                          },
                          expression: "constitute"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-6" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: {
                            placeholder: "Escriba y presione enter",
                            label: "Relación"
                          },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.addRelation($event)
                            }
                          },
                          model: {
                            value: _vm.relation,
                            callback: function($$v) {
                              _vm.relation = $$v
                            },
                            expression: "relation"
                          }
                        }),
                        _c("vs-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Agregar relación",
                              expression: "'Agregar relación'"
                            }
                          ],
                          staticClass: "mt-5 pt-3 ml-2 cursor-pointer",
                          attrs: {
                            icon: "add_circle_outline",
                            size: "medium",
                            color: "success"
                          },
                          on: { click: _vm.addRelation }
                        })
                      ],
                      1
                    ),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.relationError) + " ")
                    ]),
                    _vm.relations.length
                      ? _c("div", { staticClass: "mt-3 scrollNote" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.relations, function(
                              currentRelation,
                              index
                            ) {
                              return _c(
                                "li",
                                { key: index, staticClass: "mt-1" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              index + 1 + ". " + currentRelation
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("vs-icon", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.right",
                                            value: "Borrar relación",
                                            expression: "'Borrar relación'",
                                            modifiers: { right: true }
                                          }
                                        ],
                                        staticClass: "ml-2 cursor-pointer",
                                        attrs: {
                                          icon: "remove_circle_outline",
                                          size: "small",
                                          color: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeRelation(
                                              currentRelation
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-6 mt-3" },
                    [
                      _c("vs-input", {
                        staticClass: "w-100",
                        attrs: { label: "Es parte de" },
                        model: {
                          value: _vm.isPartOf,
                          callback: function($$v) {
                            _vm.isPartOf = $$v
                          },
                          expression: "isPartOf"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6 mt-3" },
                    [
                      _c("label", [_vm._v("Acceso")]),
                      _c("b-form-select", {
                        staticClass: "w-100",
                        attrs: { options: _vm.access },
                        model: {
                          value: _vm.accessRights,
                          callback: function($$v) {
                            _vm.accessRights = $$v
                          },
                          expression: "accessRights"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "col-6 mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("vs-input", {
                          staticClass: "w-100",
                          attrs: {
                            placeholder: "Escriba y presione enter",
                            label: "Nota del archivero"
                          },
                          on: {
                            keydown: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.addNote($event)
                            }
                          },
                          model: {
                            value: _vm.note,
                            callback: function($$v) {
                              _vm.note = $$v
                            },
                            expression: "note"
                          }
                        }),
                        _c("vs-icon", {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Agregar nota",
                              expression: "'Agregar nota'"
                            }
                          ],
                          staticClass: "mt-5 pt-3 ml-2 cursor-pointer",
                          attrs: {
                            icon: "add_circle_outline",
                            size: "medium",
                            color: "success"
                          },
                          on: { click: _vm.addNote }
                        })
                      ],
                      1
                    ),
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(" " + _vm._s(_vm.noteError) + " ")
                    ]),
                    _vm.notes.length
                      ? _c("div", { staticClass: "mt-3 scrollNote" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.notes, function(currentNote, index) {
                              return _c(
                                "li",
                                { key: index, staticClass: "mt-1" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              index + 1 + ". " + currentNote
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("vs-icon", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.right",
                                            value: "Borrar nota",
                                            expression: "'Borrar nota'",
                                            modifiers: { right: true }
                                          }
                                        ],
                                        staticClass: "ml-2 cursor-pointer",
                                        attrs: {
                                          icon: "remove_circle_outline",
                                          size: "small",
                                          color: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeNote(currentNote)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-6 mt-3" },
                    [
                      _c("label", [_vm._v("Lengua o idioma")]),
                      _c("b-form-select", {
                        staticClass: "w-100",
                        attrs: {
                          "value-field": "label",
                          "text-field": "label",
                          options: _vm.languageOptions
                        },
                        on: { change: _vm.addLanguage },
                        model: {
                          value: _vm.language,
                          callback: function($$v) {
                            _vm.language = $$v
                          },
                          expression: "language"
                        }
                      }),
                      _c("small", { staticClass: "text-danger" }, [
                        _vm._v(" " + _vm._s(_vm.langError) + " ")
                      ]),
                      _vm.languages.length
                        ? _c("div", { staticClass: "mt-3 scrollNote" }, [
                            _c(
                              "ul",
                              _vm._l(_vm.languages, function(
                                currentLang,
                                index
                              ) {
                                return _c(
                                  "li",
                                  { key: index, staticClass: "mt-1" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                index + 1 + ". " + currentLang
                                              ) +
                                              " "
                                          )
                                        ]),
                                        _c("vs-icon", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.right",
                                              value: "Borrar",
                                              expression: "'Borrar'",
                                              modifiers: { right: true }
                                            }
                                          ],
                                          staticClass: "ml-2 cursor-pointer",
                                          attrs: {
                                            icon: "remove_circle_outline",
                                            size: "small",
                                            color: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeLang(currentLang)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.language === "Otro"
                    ? _c(
                        "div",
                        { staticClass: "col-6 mt-3" },
                        [
                          _c("vs-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              label: "Lenguaje",
                              placeholder: "Escriba la lengua o idioma",
                              "data-vv-as": "idioma",
                              name: "language",
                              danger: _vm.errors.has("metadata.language"),
                              "danger-text": _vm.errors.first(
                                "metadata.language"
                              ),
                              success:
                                !_vm.errors.has("metadata.language") &&
                                _vm.otherLanguage.length > 0
                            },
                            model: {
                              value: _vm.otherLanguage,
                              callback: function($$v) {
                                _vm.otherLanguage = $$v
                              },
                              expression: "otherLanguage"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _c("div", { staticClass: "row mt-5" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 mt-5 text-right" },
                    [
                      _c(
                        "vs-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "",
                              expression: "''"
                            }
                          ],
                          staticClass: "mr-2 btn btn-primary",
                          on: { click: _vm.goBack }
                        },
                        [_vm._v(" Volver ")]
                      ),
                      _c(
                        "vs-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "",
                              expression: "''"
                            }
                          ],
                          staticClass: "mr-2 btn btn-success",
                          on: { click: _vm.save }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }